// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.order-page {
  width: 100%;
  height: auto;
background: #f2eee6;
  display: flex;
  flex-direction: column;
}

.order-page .order-account-header {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f2eee6;
  color: #10202b;
  box-sizing: border-box;
}

.order-page .order-account-header h1 {
  margin: 0;
  font-family: "Playfair Display", serif;
  font-size: 44px;
  font-weight: 400;
  line-height: 1;
}

.order-page .order-account-header span {
  width: 42px;
  height: 1px;
  margin-top: 14px;
  background: #b88a44;
}

.order-page .order-account-header p {
  margin: 12px 0 0;
  color: #5f6b73;
  font: 400 13px/1.5 "Poppins", sans-serif;
  letter-spacing: .025em;
}
.order-page .order-container {
  margin-top: 32px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
}

.order-page .order-left {
  width: 860px;
  height: auto;
}

.order-page .order-right {
  width: 360px;
  height: auto;
  margin-top: 86px;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
}

/* =================== RIGHT INFO BOX =================== */
.order-page .order-right .order-info-box {

width: 360px;

padding: 30px; /* Increased padding for a more premium, spacious feel */

display: flex;

flex-direction: column;

align-items: center;

background: #fbf8f2;

box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05); /* Softer, modern luxury shadow */

border-radius: 20px;

border: 1px solid rgba(16, 32, 43, 0.10);

margin-bottom: 25px;

}.order-page .order-right .order-info-box .member-box {

display: flex;

flex-direction: column;

align-items: center;

}.order-page .order-right .order-info-box .liner {

width: 100%;

border: 0.5px solid rgba(16, 32, 43, 0.10);

margin-top: 30px;

margin-bottom: 20px;

}/* --- USER PROFILE SECTION --- */.order-page .order-info-box .order-user-img {

position: relative;

display: flex;

flex-direction: column;

align-items: center;

}.order-page .order-info-box .order-user-avatar {

width: 110px;

height: 110px;

object-fit: cover;

border-radius: 50%; /* Rounded profile for a classic luxury look */

border: 2px solid #b88a44; /* Subtle gold trim */

padding: 3px;

}.order-page .order-info-box .order-user-name {

margin-top: 15px;

font-family: 'Playfair Display', serif; /* Matching your luxury header font */

font-weight: 600;

font-size: 24px;

color: #10202b;

}.order-page .order-info-box .order-user-prof {

font-family: 'Poppins', sans-serif;

font-size: 14px;

letter-spacing: 1px;

text-transform: uppercase;

color: #b88a44;

}/* --- INPUT FIELDS & CARDS --- */.order-page .order-info-box .card-input,.order-page .order-info-box .card-half-input {

margin-top: 15px;

padding: 12px 15px;

width: 100%;

background: #e8e1d7;

border: 1px solid rgba(16, 32, 43, 0.10);

border-radius: 8px;

font-family: 'Poppins', sans-serif;

font-size: 14px;

color: #10202b;

transition: border 0.3s ease;

box-sizing: border-box;

}.order-page .order-info-box .card-input:focus,.order-page .order-info-box .card-half-input:focus {

border-color: #b88a44;

outline: none;

}.order-page .order-info-box .cards-box {

margin-top: 15px;

width: 100%;

display: flex;

flex-direction: row;

gap: 15px;

box-sizing: border-box;

}.order-page .order-info-box .card-half-input {

flex: 1 1;

min-width: 0;

}
/* =================== LEFT NAV (TABS) =================== */
.order-page .order-left .order-nav-frame {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid rgba(16, 32, 43, 0.10);
  background: #e8e1d7;
}


.order-page .order-left .order-nav-frame .table-list,
.order-page .order-left .order-nav-frame .table_list {
  width: auto;
  min-height: 40px;
}

.order-page .order-left .order-nav-frame .MuiTabs-flexContainer {
  gap: 30px;
}

.order-page .order-left .order-nav-frame .MuiTab-root {
  min-width: 0;
  min-height: 40px;
  padding: 0 4px;
  color: #10202b;
  font: 500 10px/1 "Poppins", sans-serif;
  letter-spacing: .12em;
}

.order-page .order-left .order-nav-frame .MuiTab-root.Mui-selected {
  color: #b88a44;
}

.order-page .order-left .order-nav-frame .MuiTabs-indicator {
  height: 1px;
  background: #b88a44;
}

.order-page .order-left .order-nav-frame > .MuiBox-root {
  border-bottom: 0;
}

.order-page .css-lgsv261 {
  width: 75%;
}



.order-page .css-heg063-MuiTabs-flexContainer {
  justify-content: space-between;
}

/* =================== MAIN CONTENT =================== */
.order-page .order-main-content .order-main-box {
  position: relative;
  width: 100%;
  max-height: 285px;
  margin-bottom: 25px;
  background: #fbf8f2;
  box-shadow: 0 10px 30px rgba(16, 32, 43, 0.08);
  border: 1px solid rgba(16, 32, 43, 0.10);
  border-radius: 12px;
  color: #10202b;
}

.order-page .order-main-content .order-main-box .order-box-scroll {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 105px;
  max-height: 205px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow-y: scroll;
}

.order-page .order-main-content .order-main-box .order-box-scroll::-webkit-scrollbar {
  width: 7px;
}

.order-page .order-main-content .order-main-box .order-box-scroll::-webkit-scrollbar-thumb {
  background-color: #b88a44;
  border-radius: 5px;
}

.order-page .order-box-scroll .orders-name-price {
  position: relative;
  height: 47px;
  margin-top: 5px;
  margin-left: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.order-page .order-box-scroll .orders-name-price .order-product-img {
  position: relative;
  width: 50px;
  height: 47px;
  border-radius: 29px;
  background-size: cover;
}

.order-page .order-box-scroll .orders-name-price .title-product {
  position: relative;
  width: 260px;
  height: 36px;
  margin-left: 20px;
  font-family: 'Playfair Display', serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  color: #10202b;
}

.order-page .order-box-scroll .orders-name-price .price-box {
  position: relative;
  max-width: 170px;
  height: 100%;
  margin-left: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.order-page .order-box-scroll .orders-name-price .price-box p {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  color: #b88a44;
}

.order-page .order-main-content .order-main-box .total-price-box {
  position: relative;
  width: 100%;
  height: auto; /* Changed from fixed height to auto to let content breathe */
  min-height: 60px;
  padding: 10px;
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; /* Better distribution */
  background: #e8e1d7;
  border-top: 1px solid rgba(16, 32, 43, 0.10);
  box-sizing: border-box;
}

.order-page .order-main-content .total-price-box .cancel-button {
  border-radius: 10px;
  background: transparent;
  color: #b88a44;
  border: 1px solid #b88a44;
  max-height: 40px;
  transition: 0.3s;
}

.order-page .order-main-content .total-price-box .cancel-button:hover {
  background: #b88a44;
  color: #10202b;
}

.order-page .order-main-content .total-price-box .pay-button {
  background: #b88a44;
  color: #10202b;
  border-radius: 10px;
  max-height: 40px;
  font-weight: 600;
  border: none;
}

.order-page .order-main-content .total-price-box .verify-button {
  background: #fbf8f2;
  color: #b88a44;
  border: 1px solid #b88a44;
  border-radius: 10px;
}

.order-page .order-main-content .order-main-box .total-price-box .box-total {
  position: relative;
  max-width: 535px;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.order-page .total-price-box .box-total p,
.order-page .total-price-box .box-total .data-compl {
  margin: 0; /* Remove side margins that cause crowding */
  font-family: 'Poppins', sans-serif;
  font-size: 12px; /* Slightly smaller to prevent wrapping */
  line-height: 1.4;
  color: #10202b;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/css/order.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;AACd,mBAAmB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,2DAA2D;AAC3D;;AAEA,YAAY;;AAEZ,aAAa,EAAE,wDAAwD;;AAEvE,aAAa;;AAEb,sBAAsB;;AAEtB,mBAAmB;;AAEnB,mBAAmB;;AAEnB,6CAA6C,EAAE,iCAAiC;;AAEhF,mBAAmB;;AAEnB,wCAAwC;;AAExC,mBAAmB;;AAEnB,CAAC;;AAED,aAAa;;AAEb,sBAAsB;;AAEtB,mBAAmB;;AAEnB,CAAC;;AAED,WAAW;;AAEX,0CAA0C;;AAE1C,gBAAgB;;AAEhB,mBAAmB;;AAEnB,CAAC,iCAAiC,CAAC;;AAEnC,kBAAkB;;AAElB,aAAa;;AAEb,sBAAsB;;AAEtB,mBAAmB;;AAEnB,CAAC;;AAED,YAAY;;AAEZ,aAAa;;AAEb,iBAAiB;;AAEjB,kBAAkB,EAAE,8CAA8C;;AAElE,yBAAyB,EAAE,qBAAqB;;AAEhD,YAAY;;AAEZ,CAAC;;AAED,gBAAgB;;AAEhB,sCAAsC,EAAE,qCAAqC;;AAE7E,gBAAgB;;AAEhB,eAAe;;AAEf,cAAc;;AAEd,CAAC;;AAED,kCAAkC;;AAElC,eAAe;;AAEf,mBAAmB;;AAEnB,yBAAyB;;AAEzB,cAAc;;AAEd,CAAC,iCAAiC,CAAC;;AAEnC,gBAAgB;;AAEhB,kBAAkB;;AAElB,WAAW;;AAEX,mBAAmB;;AAEnB,wCAAwC;;AAExC,kBAAkB;;AAElB,kCAAkC;;AAElC,eAAe;;AAEf,cAAc;;AAEd,4BAA4B;;AAE5B,sBAAsB;;AAEtB,CAAC;;AAED,qBAAqB;;AAErB,aAAa;;AAEb,CAAC;;AAED,gBAAgB;;AAEhB,WAAW;;AAEX,aAAa;;AAEb,mBAAmB;;AAEnB,SAAS;;AAET,sBAAsB;;AAEtB,CAAC;;AAED,SAAO;;AAEP,YAAY;;AAEZ;AACA,4DAA4D;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;EAC/C,mBAAmB;AACrB;;;AAGA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,6DAA6D;EAC3E,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B,EAAE,wBAAwB;EACxD,mBAAmB;EACnB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,SAAS,EAAE,4CAA4C;EACvD,kCAAkC;EAClC,eAAe,EAAE,yCAAyC;EAC1D,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["\n.order-page {\n  width: 100%;\n  height: auto;\nbackground: #f2eee6;\n  display: flex;\n  flex-direction: column;\n}\n\n.order-page .order-account-header {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f2eee6;\n  color: #10202b;\n  box-sizing: border-box;\n}\n\n.order-page .order-account-header h1 {\n  margin: 0;\n  font-family: \"Playfair Display\", serif;\n  font-size: 44px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.order-page .order-account-header span {\n  width: 42px;\n  height: 1px;\n  margin-top: 14px;\n  background: #b88a44;\n}\n\n.order-page .order-account-header p {\n  margin: 12px 0 0;\n  color: #5f6b73;\n  font: 400 13px/1.5 \"Poppins\", sans-serif;\n  letter-spacing: .025em;\n}\n.order-page .order-container {\n  margin-top: 32px;\n  margin-bottom: 50px;\n  display: flex;\n  flex-direction: row;\n}\n\n.order-page .order-left {\n  width: 860px;\n  height: auto;\n}\n\n.order-page .order-right {\n  width: 360px;\n  height: auto;\n  margin-top: 86px;\n  margin-left: 30px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* =================== RIGHT INFO BOX =================== */\n.order-page .order-right .order-info-box {\n\nwidth: 360px;\n\npadding: 30px; /* Increased padding for a more premium, spacious feel */\n\ndisplay: flex;\n\nflex-direction: column;\n\nalign-items: center;\n\nbackground: #fbf8f2;\n\nbox-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05); /* Softer, modern luxury shadow */\n\nborder-radius: 20px;\n\nborder: 1px solid rgba(16, 32, 43, 0.10);\n\nmargin-bottom: 25px;\n\n}.order-page .order-right .order-info-box .member-box {\n\ndisplay: flex;\n\nflex-direction: column;\n\nalign-items: center;\n\n}.order-page .order-right .order-info-box .liner {\n\nwidth: 100%;\n\nborder: 0.5px solid rgba(16, 32, 43, 0.10);\n\nmargin-top: 30px;\n\nmargin-bottom: 20px;\n\n}/* --- USER PROFILE SECTION --- */.order-page .order-info-box .order-user-img {\n\nposition: relative;\n\ndisplay: flex;\n\nflex-direction: column;\n\nalign-items: center;\n\n}.order-page .order-info-box .order-user-avatar {\n\nwidth: 110px;\n\nheight: 110px;\n\nobject-fit: cover;\n\nborder-radius: 50%; /* Rounded profile for a classic luxury look */\n\nborder: 2px solid #b88a44; /* Subtle gold trim */\n\npadding: 3px;\n\n}.order-page .order-info-box .order-user-name {\n\nmargin-top: 15px;\n\nfont-family: 'Playfair Display', serif; /* Matching your luxury header font */\n\nfont-weight: 600;\n\nfont-size: 24px;\n\ncolor: #10202b;\n\n}.order-page .order-info-box .order-user-prof {\n\nfont-family: 'Poppins', sans-serif;\n\nfont-size: 14px;\n\nletter-spacing: 1px;\n\ntext-transform: uppercase;\n\ncolor: #b88a44;\n\n}/* --- INPUT FIELDS & CARDS --- */.order-page .order-info-box .card-input,.order-page .order-info-box .card-half-input {\n\nmargin-top: 15px;\n\npadding: 12px 15px;\n\nwidth: 100%;\n\nbackground: #e8e1d7;\n\nborder: 1px solid rgba(16, 32, 43, 0.10);\n\nborder-radius: 8px;\n\nfont-family: 'Poppins', sans-serif;\n\nfont-size: 14px;\n\ncolor: #10202b;\n\ntransition: border 0.3s ease;\n\nbox-sizing: border-box;\n\n}.order-page .order-info-box .card-input:focus,.order-page .order-info-box .card-half-input:focus {\n\nborder-color: #b88a44;\n\noutline: none;\n\n}.order-page .order-info-box .cards-box {\n\nmargin-top: 15px;\n\nwidth: 100%;\n\ndisplay: flex;\n\nflex-direction: row;\n\ngap: 15px;\n\nbox-sizing: border-box;\n\n}.order-page .order-info-box .card-half-input {\n\nflex: 1;\n\nmin-width: 0;\n\n}\n/* =================== LEFT NAV (TABS) =================== */\n.order-page .order-left .order-nav-frame {\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-bottom: 1px solid rgba(16, 32, 43, 0.10);\n  background: #e8e1d7;\n}\n\n\n.order-page .order-left .order-nav-frame .table-list,\n.order-page .order-left .order-nav-frame .table_list {\n  width: auto;\n  min-height: 40px;\n}\n\n.order-page .order-left .order-nav-frame .MuiTabs-flexContainer {\n  gap: 30px;\n}\n\n.order-page .order-left .order-nav-frame .MuiTab-root {\n  min-width: 0;\n  min-height: 40px;\n  padding: 0 4px;\n  color: #10202b;\n  font: 500 10px/1 \"Poppins\", sans-serif;\n  letter-spacing: .12em;\n}\n\n.order-page .order-left .order-nav-frame .MuiTab-root.Mui-selected {\n  color: #b88a44;\n}\n\n.order-page .order-left .order-nav-frame .MuiTabs-indicator {\n  height: 1px;\n  background: #b88a44;\n}\n\n.order-page .order-left .order-nav-frame > .MuiBox-root {\n  border-bottom: 0;\n}\n\n.order-page .css-lgsv261 {\n  width: 75%;\n}\n\n\n\n.order-page .css-heg063-MuiTabs-flexContainer {\n  justify-content: space-between;\n}\n\n/* =================== MAIN CONTENT =================== */\n.order-page .order-main-content .order-main-box {\n  position: relative;\n  width: 100%;\n  max-height: 285px;\n  margin-bottom: 25px;\n  background: #fbf8f2;\n  box-shadow: 0 10px 30px rgba(16, 32, 43, 0.08);\n  border: 1px solid rgba(16, 32, 43, 0.10);\n  border-radius: 12px;\n  color: #10202b;\n}\n\n.order-page .order-main-content .order-main-box .order-box-scroll {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  min-height: 105px;\n  max-height: 205px;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  overflow-y: scroll;\n}\n\n.order-page .order-main-content .order-main-box .order-box-scroll::-webkit-scrollbar {\n  width: 7px;\n}\n\n.order-page .order-main-content .order-main-box .order-box-scroll::-webkit-scrollbar-thumb {\n  background-color: #b88a44;\n  border-radius: 5px;\n}\n\n.order-page .order-box-scroll .orders-name-price {\n  position: relative;\n  height: 47px;\n  margin-top: 5px;\n  margin-left: 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.order-page .order-box-scroll .orders-name-price .order-product-img {\n  position: relative;\n  width: 50px;\n  height: 47px;\n  border-radius: 29px;\n  background-size: cover;\n}\n\n.order-page .order-box-scroll .orders-name-price .title-product {\n  position: relative;\n  width: 260px;\n  height: 36px;\n  margin-left: 20px;\n  font-family: 'Playfair Display', serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 36px;\n  color: #10202b;\n}\n\n.order-page .order-box-scroll .orders-name-price .price-box {\n  position: relative;\n  max-width: 170px;\n  height: 100%;\n  margin-left: 150px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.order-page .order-box-scroll .orders-name-price .price-box p {\n  font-family: 'Poppins', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 27px;\n  color: #b88a44;\n}\n\n.order-page .order-main-content .order-main-box .total-price-box {\n  position: relative;\n  width: 100%;\n  height: auto; /* Changed from fixed height to auto to let content breathe */\n  min-height: 60px;\n  padding: 10px;\n  margin: 10px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between; /* Better distribution */\n  background: #e8e1d7;\n  border-top: 1px solid rgba(16, 32, 43, 0.10);\n  box-sizing: border-box;\n}\n\n.order-page .order-main-content .total-price-box .cancel-button {\n  border-radius: 10px;\n  background: transparent;\n  color: #b88a44;\n  border: 1px solid #b88a44;\n  max-height: 40px;\n  transition: 0.3s;\n}\n\n.order-page .order-main-content .total-price-box .cancel-button:hover {\n  background: #b88a44;\n  color: #10202b;\n}\n\n.order-page .order-main-content .total-price-box .pay-button {\n  background: #b88a44;\n  color: #10202b;\n  border-radius: 10px;\n  max-height: 40px;\n  font-weight: 600;\n  border: none;\n}\n\n.order-page .order-main-content .total-price-box .verify-button {\n  background: #fbf8f2;\n  color: #b88a44;\n  border: 1px solid #b88a44;\n  border-radius: 10px;\n}\n\n.order-page .order-main-content .order-main-box .total-price-box .box-total {\n  position: relative;\n  max-width: 535px;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.order-page .total-price-box .box-total p,\n.order-page .total-price-box .box-total .data-compl {\n  margin: 0; /* Remove side margins that cause crowding */\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px; /* Slightly smaller to prevent wrapping */\n  line-height: 1.4;\n  color: #10202b;\n  text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
